import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { FacilityType } from '../../types/facilities'; // Add this import

export interface UiState {
  isGenerating: boolean;
  selectedFacilityType: FacilityType | null;
  selectedEntity: any | null;
  currentPage: string;
  infoPanelContent: string;
  contextPanelContent: string;
}

const initialState: UiState = {
  isGenerating: false,
  selectedFacilityType: null,
  selectedEntity: null,
  currentPage: 'map',
  infoPanelContent: '',
  contextPanelContent: '',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsGenerating: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
    setSelectedFacilityType: (state, action: PayloadAction<FacilityType | null>) => {
      state.selectedFacilityType = action.payload;
    },
    setSelectedEntity: (state, action: PayloadAction<any | null>) => {
      state.selectedEntity = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload;
    },
    setInfoPanelContent: (state, action: PayloadAction<string>) => {
      state.infoPanelContent = action.payload;
    },
    setContextPanelContent: (state, action: PayloadAction<string>) => {
      state.contextPanelContent = action.payload;
    },
  },
});

export const {
  setIsGenerating,
  setSelectedFacilityType,
  setSelectedEntity,
  setCurrentPage,
  setInfoPanelContent,
  setContextPanelContent,
} = uiSlice.actions;

export const selectIsGenerating = (state: RootState) => state.ui.isGenerating;
export const selectSelectedFacilityType = (state: RootState) => state.ui.selectedFacilityType;
export const selectCurrentPage = (state: RootState) => state.ui.currentPage;
export const selectInfoPanelContent = (state: RootState) => state.ui.infoPanelContent;
export const selectContextPanelContent = (state: RootState) => state.ui.contextPanelContent;

export default uiSlice.reducer;